const personType = state => (state.person ? state.person.type : null);

export default {
  personType,
};
